<template>
  <div class="service-top">
    <service-header :signedIn="signedInUser !== null"/>
    <section class="hero">
      <div class="hero-description">
        <h1>
          <span class="supplement">
            ＼誰でも簡単に使える／
          </span>
          チャット、WEB会議<br>
          <span class="text-service">一つにまとめて簡単に</span>
        </h1>
        <p>
          オンラインのコミュニケーションって難しいものじゃない。誰でも誘えて、誰でも簡単に使えて、どんな職種もどんな仲間も、みんなで安全に使えるコミュニケーションツールはSharewind｜シェアウィンド。
        </p>
        <div class="btn-wrapper">
          <template v-if="!signedInUser">
            <proa-service-button
              class="sign-up"
              text="無料アカウントを作成"
              to="sign_up" />
            <proa-service-button
              variant="outline-primary round"
              text="ログイン"
              to="sign_in" />
          </template>
          <template v-else>
            <proa-service-button
              text="マイスペース"
              to="my_space" />
          </template>
        </div>
      </div>
      <div class="hero-img">
        <img :src="require('@/assets/images/service/image_application.png')" alt="アプリケーションイメージ"/>
      </div>
    </section>
    <section class="group">
      <div class="group-inner">
        <div class="description-wrapper">
          <h2>
            <div>グループを作って、</div>
            <div>誘って、話して、繋がろう。</div>
          </h2>
          <p>
            Sharewindは、登録した瞬間から誰でも簡単に使えます。例えば、テレワークやバイトなど仕事の連絡、家族間や仲間同士のちょっとした雑談など。さまざまシーンでのコミュニケーションをサポートし、まるですぐ側にいるかのようなコミュニケーションを実現します。
          </p>
          <proa-service-button
            variant="outline-secondary square"
            text="初めての方へ"
            to="service/about"
            arrow-right
          />
        </div>
        <div class="img-wrapper">
          <img :src="require('@/assets/images/service/image_group.png')" alt="グループイメージ"/>
        </div>
      </div>
    </section>
    <section class="chat">
      <h2>
        シンプルなチャットと<br class="sp">WEB会議<br>
        Sharewindなら誰でも<br class="sp">簡単に使えます
      </h2>
      <p class="section-description">
        新しいインターネットツールは「操作が難しそう」という不安から利用をためらう人もいるかもしれません。必要な機能だけに絞ったSharewindのわかりやすい画面は、マニュアルがなくても誰でも直感的に操作することができます。職種や年代を問わず、幅広いオンラインコミュニケーションを支えます。
      </p>
      <div class="feature-wrapper">
        <div class="img-wrapper">
          <img :src="require('@/assets/images/service/image_chat.png')" alt="チャットイメージ"/>
        </div>
        <div class="feature-description-wrapper">
          <h3 class="text-service">
            グループチャット、ダイレクトメッセージ
          </h3>
          <p>
            グループを作って、メンバー間のコミュニケーションをスムーズにリアルタイムで行うことができ、後から参加した人も今までのみんなの会話を見ることができます。リモートワークでコミュニケーションに抜けや漏れが生じやすくなりますが、これまでの記録が残ることで「聞いていない、忘れていた」という事態を起こしません。 複数人のグループチャットに加え、ダイレクトメッセージを利用することで１対１のプライベートなやり取りも可能です。
          </p>
        </div>
      </div>
      <div class="feature-wrapper">
        <div class="feature-description-wrapper">
          <h3 class="text-service">
            WEB会議、カフェ
          </h3>
          <p>
            時間や参加者を指定して事前予約をしたり、今すぐ仲間を誘ったり、誰でも簡単にビデオ通話を行うことが出来ます。 カフェは思い立ったら仲間を誘い始められ、途中で他の人が加わったり、先に抜けたり、会社の休憩スペースの雑談をイメージして作られています。
          </p>
        </div>
        <div class="img-wrapper">
          <img :src="require('@/assets/images/service/image_meeting.png')" alt="会議イメージ"/>
        </div>
      </div>
      <proa-service-button
        variant="outline-secondary square"
        text="機能を見る"
        to="service/features"
        arrow-right
      />
    </section>
    <section class="project">
      <h2>
        大人数で<br class="sp">プロジェクト管理も<br>
        ビジネスに最適な<br>
        プロフェッショナルプラン
      </h2>
      <p class="section-description">
        ビジネスを簡単で直感的に。事業規模や目的に合わせてプロフェッショナル、エンタープライズプランをご用意。チームワークを最大限に活かせる働く環境を構築できます。
      </p>
      <div class="img-wrapper">
        <div class="project-features">
          <div class="top-row">
            <div class="features-item">
              <p>
                グループ数<br>
                無制限
              </p>
            </div>
            <div class="features-item primary">
              <p>
                プロジェクト<br>
                タスク機能
              </p>
            </div>
            <div class="features-item">
              <p>
                独自<br>
                ドメイン
              </p>
            </div>
          </div>
          <div class="bottom-row">
            <div class="features-item primary">
              <p>
                外部連携
              </p>
            </div>
            <div class="features-item">
              <p>
                カスタマイズ
              </p>
            </div>
          </div>
        </div>
        <img :src="require('@/assets/images/service/image_project.png')" alt="プロジェクトイメージ"/>
      </div>
      <proa-service-button
        variant="outline-secondary square"
        text="プラン別料金一覧"
        to="service/plans"
        arrow-right
      />
    </section>
    <service-footer
      :signedIn="signedInUser !== null"
      :route="$route.name"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ServiceHeader from '@/components/molecules/service/ServiceHeader.vue'
import ServiceFooter from '@/components/molecules/service/ServiceFooter.vue'

export default {
  name: 'ServiceIndex',
  components: {
    ServiceHeader,
    ServiceFooter
  },
  computed: {
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.service-top {
  width: 100%;

  br.sp {

    @include mq(sm) {
      display: none;
    }
  }

  section {
    padding: 0 20px;

    @include mq(xl) {
      padding: 0;
    }

    &.group,
    &.chat,
    &.project {
      background-color: white;
    }

    h2 {
      word-break: keep-all;
      font-size: 26px;
      font-weight: 600;

      @include mq(sm) {
        font-size: 32px;
      }
    }

    h3 {
      font-size: 24px;
      font-weight: 600;
      margin-bottom: 30px;

      @include mq(md) {
        margin-bottom: 40px;
      }
    }

    .section-description {
      font-size: 15px;
      max-width: 600px;
    }

    .img-wrapper {
      width: 100%;

      @include mq(md) {
        width: 500px;
      }

      img {
        width: 100%;
      }
    }

    .feature-wrapper {
      display: flex;
      justify-content: center;
      flex-direction: column;
      max-width: 1100px;
      width: 100%;
      margin-bottom: 100px;

      &:nth-child(even) {
        flex-direction: column-reverse;
      }

      @include mq(sm) {
        flex-direction: row;
        justify-content: space-between;

        &:nth-child(even) {
          flex-direction: row;
        }
      }

      @include mq(lg) {
        margin-bottom: 120px;
      }

      .feature-description-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;

        @include mq(md) {
          align-items: flex-start;
        }

        p {
          word-break: break-all;
          max-width: 100%;
          margin-bottom: 30px;

          @include mq(sm) {
            max-width: 300px;
          }

          @include mq(md) {
            margin-bottom: 40px;
          }

          @include mq(lg) {
            max-width: 400px;
          }

          @include mq(xl) {
            max-width: 500px;
          }
        }
      }

      .img-wrapper {
        margin-bottom: 30px;

        @include mq(lg) {
          margin-bottom: 0;
        }
      }
    }
  }

  .hero {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 755px;
    padding: 100px 0;

    @include mq(lg) {
      flex-direction: row;
      justify-content: center;
      align-items: center;
      padding: 0;
    }

    &-description {
      position: relative;
      margin-right: 0;
      z-index: 1;

      @include mq(lg) {
        margin-right: 500px;
      }

      h1 {
        text-align: center;
        position: relative;
        font-size: 30px;
        font-weight: 600;
        line-height: 1.3;
        margin-bottom: 35px;

        @include mq(md) {
          font-size: 42px;
        }

        @include mq(lg) {
          text-align: left;
        }

        .supplement {
          position: absolute;
          top: -30px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 18px;
          white-space: nowrap;

          @include mq(lg) {
            left: 0;
            transform: translateX(0);
          }
        }
      }

      p {
        text-align: center;
        font-size: 16px;
        font-weight: 600;
        line-height: 1.6;
        margin: 0 auto 45px auto;
        max-width: 300px;

        @include mq(md) {
          max-width: 400px;
        }

        @include mq(lg) {
          text-align: left;
          max-width: 300px;
          margin: 0 0 55px 0;
        }
      }

      .btn-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;

        @include mq(lg) {
          align-items: flex-start;
        }

        .sign-up {
          margin-bottom: 15px;
        }
      }
    }

    &-img {
      position: relative;
      top: 50px;
      right: -5%;

      @include mq(lg) {
        position: absolute;
        top: 50%;
        transform: translate(0, -50%);
        max-width: 69%;
        height: 100%;
      }

      img {
        width: 100%;

        @include mq(lg) {
          width: auto;
          max-height: 100%;
        }
      }
    }
  }

  .group {
    padding-top: 60px;

    @include mq(md) {
      padding-top: 95px;
    }

    &-inner {
      display: flex;
      flex-direction: column-reverse;
      align-items: flex-start;
      max-width: 1100px;
      margin: 0 auto;

      @include mq(sm) {
        flex-direction: row;
        justify-content: space-between;
      }

      .description-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;

        @include mq(sm) {
          align-items: flex-start;
        }

        h2 {
          line-height: 1.3;
          text-align: center;
          margin-bottom: 35px;

          @include mq(sm) {
            text-align: left;
          }
        }

        p {
          font-size: 15px;
          line-height: 1.6;
          max-width: 100%;
          margin-bottom: 40px;

          @include mq(sm) {
            max-width: 500px;
          }
        }
      }
    }
  }

  .chat {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 110px;

    h2 {
      line-height: 1.3;
      text-align: center;
      margin-bottom: 40px;
    }

    .feature-wrapper {
      @include mq(lg) {
        margin-bottom: 80px;
      }
    }

    .section-description {
      line-height: 1.6;
      margin-bottom: 40px;

      @include mq(md) {
        margin-bottom: 60px;
      }
    }

    .feature-description-wrapper p {
      font-size: 15px;
      line-height: 1.6;
    }

  }

  .project {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px 20px 130px 20px;

    @include mq(md) {
      padding: 150px 0 130px 0;
    }

    h2 {
      line-height: 1.3;
      text-align: center;
      margin-bottom: 30px;
    }

    .section-description {
      line-height: 1.6;
      margin-bottom: 30px;

      @include mq(sm) {
        margin-bottom: 80px;
      }
    }

    .img-wrapper {
      position: relative;
      margin-bottom: 55px;
      width: 100%;

      @include mq(sm) {
        width: 800px;
      }

      .project-features {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-bottom: -15px;
        z-index: 1;

        @include mq(sm) {
          position: absolute;
          top: -30px;
          left: 51%;
          transform: translateX(-50%);
          min-width: 100vw;
          margin-bottom: 0;
        }
        .top-row,
        .bottom-row {
          display: flex;

          .features-item {
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: $secondary-color;
            border: 4px solid white;
            border-radius: 50%;
            width: 108px;
            height: 108px;
            margin-right: 12px;

            &.primary {
              background-color: $service-primary-color;
            }

            p {
              word-break: keep-all;
              text-align: center;
              color: white;
              font-size: 14px;
              font-weight: 600;
              margin: 0;
            }
          }
        }

        .bottom-row .features-item:last-child {
          margin-right: 0;
        }

      }
    }
  }
}
</style>
